import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../src/assets/css/Mystyle.css';
import '../src/assets/css/responsive.css';
import "@fontsource/poppins"; 
import "@fontsource/poppins/400.css"; 
import "@fontsource/poppins/400-italic.css"; 
import '@fortawesome/fontawesome-free/css/all.css';
import '@fontsource/bodoni-moda/400.css';
import "@fontsource/roboto/400.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
reportWebVitals();
